import React from 'react';
import {useEffect, useRef} from 'react';
import { connect } from 'react-redux';
import { setOutputFileAttribute } from './thunks';
import moment from 'moment';
import WebViewer from '@pdftron/webviewer';
import { getMomentDate } from './util'
import setting from './setting';
import './ReviewPlace.css';

let annotManager = null;
const serializer = new XMLSerializer();
const connection = new WebSocket(`${setting.websocket_server}`);
window.listenerLoaded = false;

const ReviewPlace = ({ files = [], userInfo = {}, reviewInfo, groupInfo, 
  allowEdit = false, setFileAttribute }) => {
  
  const getSelectedFile = (files) => {
    const [selectedFile] = files.filter( file => file && file.isSelected );
    return selectedFile;
  }

  const getSelectedFileName = (files) => {
    const [selectedFile] = files.filter( file => file && file.isSelected );
    return selectedFile && selectedFile.fileName;
  }
  
  const getFullFileLocation = (fileLocation) => {
    let selectedFile = getSelectedFile(files);
    let isDocReviewFile = selectedFile.fileNameDocument ? true : false;
    let fullFileLocation = '';
    if (isDocReviewFile) {
      let milestone = reviewInfo.milestone ? reviewInfo.milestone : '';
      let filePath = selectedFile.filePath.split('\\').join('/');
      // console.log('>>> getFullFileLocation:', milestone, filePath);
      if (milestone && (milestone !== 'undefined')) {
        fullFileLocation = `/workspace/` +
          `${reviewInfo.program}/${reviewInfo.study}/${milestone}/` +
          `${filePath}/${reviewInfo.groupId}/${selectedFile.fileName}`;
      } else {
        fullFileLocation = `/workspace/` +
          `${reviewInfo.program}/${reviewInfo.study}/` +
          `${filePath}/${reviewInfo.groupId}/${selectedFile.fileName}`;
      }
    } else {
      fullFileLocation = `/workspace/` +
        `${reviewInfo.program}/${reviewInfo.study}/` +
        `${reviewInfo.milestone}/Stats/Production%20Output/pdf/` + 
        `${reviewInfo.groupId}/${fileLocation}`;
    }
    console.log('fullFileLocation:', fullFileLocation);
    return fullFileLocation;
  }
  
  const viewer = useRef(null);
  let filename = getSelectedFileName(files);
  window.documentId = filename ? filename + '.pdf' : '';
  let fileLocation = filename ? window.documentId : '';
  // console.log('fileLocation:', fileLocation);
  
  useEffect(function() {
    // console.log('>>> useEffect fileLocation:', fileLocation);
    // console.log('>>> useEffect userInfo:', userInfo);
    if (!window.viewerInstance && !window.initWebViewerCreate) {
      window.initWebViewerCreate = true;
      try {
        WebViewer(
          {
            licenseKey: 'Viitai LLC(viitai.com):OEM:BPS::B+:AMS(20211029):' + 
              '7BF5C7F16A564D0B1ABBC8B253086F01404F6D348D4B545435E4CFEF40A05AAA31F5C7',
            path: '/pdftron/',
            initialDoc: '',
            backendType: 'ems',
          },
          viewer.current,
        ).then((instance) => {
            window.viewerInstance = instance;
            instance.disableFeatures(instance.Feature.FilePicker);
            instance.openElements(['notesPanel']);
          }
        );
      } catch (e) {
        console.log('exception in creating viewerInstance:', e);
      }
    }
    if (window.viewerInstance) {
      let instance = window.viewerInstance;
      // hide the download and print buttons if user allowDownload is false
      // console.log('>>> userInfo:', userInfo);
      if (!userInfo.allowDownload) {
        instance.disableElements(['downloadButton']);
        instance.disableElements(['printButton']);
      }
      // console.log('instance exist:', !!instance, '; fileLocation:', fileLocation);
      if (fileLocation) {
        let fullFileLocation = getFullFileLocation(fileLocation);
        instance.loadDocument(fullFileLocation, { filename: 'file.pdf' });
        setTimeout(() => {
          window.viewerInstance.openElements(['notesPanel']);
        }, 300);
        if (!window.listenerLoaded) {
          viewer.current.addEventListener('documentLoaded', () => {
            console.log('load annocations for documentId:', window.documentId);
            loadXfdfStrings(window.documentId).then((rows) => {
              try {
                JSON.parse(rows).forEach(async row => {
                  const annotations = await annotManager.importAnnotCommand(row.xfdfString);
                  await annotManager.drawAnnotationsFromList(annotations);
                });
              } catch (e) {
                console.log('error in parsing rows:', rows);
              }
            });
          });
          window.listenerLoaded = true;
        }
        // Instance is ready here
        annotManager = instance.docViewer.getAnnotationManager();
        annotManager.setCurrentUser(userInfo && userInfo.userId);
        let dueDate = getMomentDate(groupInfo.dueDate);
        let todayDate = moment();
        let isPastDueDate = (todayDate.diff(dueDate) > 0);
        let isReadOnly = false;
        if (allowEdit) {
          if (isPastDueDate) {
            if (userInfo.is_lp || userInfo.is_rb) {
              // user is LP or RB and past due date, user can still edit
            } else {
              isReadOnly = true;
            }
          }
        } else {
          isReadOnly = true;
        }
        let selectedFile = getSelectedFile(files);
        if (selectedFile.statusId === 5) {
          // file with status = 5 (Wait for programmer update), then file is read only
          isReadOnly = true;
        }
        console.log('allowEdit', allowEdit);
        if (isReadOnly) {
          console.log('set read only on annotation manager');
          annotManager.setReadOnly(true);
        } else {
          annotManager.setReadOnly(false);
        }
        annotManager.on('annotationChanged', async e => {
          // If annotation change is from import, return
          if (e.imported) { return; }

          const xfdfString = await annotManager.exportAnnotCommand();
          // Parse xfdfString to separate multiple annotation changes to individual annotation change
          const parser = new DOMParser();
          const commandData = parser.parseFromString(xfdfString, 'text/xml');
          const addedAnnots = commandData.getElementsByTagName('add')[0];
          const modifiedAnnots = commandData.getElementsByTagName('modify')[0];
          const deletedAnnots = commandData.getElementsByTagName('delete')[0];

          // helper function to send annotation changes to WebSocket server
          const sendAnnotationChange = (annotation, action) => {
            // console.log('sendAnnotationChange:', annotation, action);
            // console.log('sendAnnotationChange documentId:', window.documentId);
            if (annotation.nodeType !== annotation.TEXT_NODE) {
              const annotationString = serializer.serializeToString(annotation);
              const innerHTML = annotation['innerHTML'];
              connection.send(JSON.stringify({
                documentId: window.documentId,
                program: reviewInfo.program,
                study: reviewInfo.study,
                milestone: reviewInfo.milestone,
                groupId: reviewInfo.groupId,
                annotationId: annotation.getAttribute('name') || innerHTML,
                xfdfString: convertToXfdf(annotationString, action),
                createUser: reviewInfo.user,
                createDate: new Date()
              }));
            }
          };
          
          // List of added annotations
          addedAnnots.childNodes.forEach((child) => {
            sendAnnotationChange(child, 'add');
          });

          // List of modified annotations
          modifiedAnnots.childNodes.forEach((child) => {
            sendAnnotationChange(child, 'modify');
          });

          // List of deleted annotations
          deletedAnnots.childNodes.forEach((child) => {
            sendAnnotationChange(child, 'delete');
          });

        });
      }
      connection.onmessage = async (message) => {
        const annotation = JSON.parse(message.data);
        console.log('received annotation:', annotation);
        const annotations = await annotManager.importAnnotCommand(annotation.xfdfString);
        await annotManager.drawAnnotationsFromList(annotations);
      }
    }
  },
  // eslint-disable-next-line
  [fileLocation, userInfo]);
  
  const loadXfdfStrings = (documentId) => {
    return new Promise((resolve, reject) => {
      let annotationUrl = `${setting.annotation_server}/annotation/get?` + 
        `documentId=${documentId}&program=${reviewInfo.program}` + 
        `&study=${reviewInfo.study}&milestone=${reviewInfo.milestone}` + 
        `&groupId=${reviewInfo.groupId}`;
      fetch(annotationUrl, {
        method: 'GET',
      }).then((res) => {
        if (res.status < 400) {
          res.text().then(xfdfStrings => {
            resolve(xfdfStrings);
          });
        } else {
          reject(res);
        }
      });
    });
  };
  
  // wrapper function to convert xfdf fragments to full xfdf strings
  const convertToXfdf = (changedAnnotation, action) => {
    let xfdfString = `<?xml version="1.0" encoding="UTF-8" ?><xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve"><fields />`;
    if (action === 'add') {
      xfdfString += `<add>${changedAnnotation}</add><modify /><delete />`;
    } else if (action === 'modify') {
      xfdfString += `<add /><modify>${changedAnnotation}</modify><delete />`;
    } else if (action === 'delete') {
      xfdfString += `<add /><modify /><delete>${changedAnnotation}</delete>`;
    }
    xfdfString += `</xfdf>`;
    return xfdfString;
  };

  const content = (
    <div className="review-container">
      <div className="webviewer" ref={viewer} style={{height: "100vh"}}></div>
    </div>
  );
  return content;
}

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  groupInfo: state.groupInfo,
  reviewInfo: state.reviewInfo,
})

const mapDispatch = dispatch => ({
  setFileAttribute: (param) => dispatch(setOutputFileAttribute(param)),
})

export default connect(mapState, mapDispatch)(ReviewPlace);
